module.exports = __webpack_public_path__ + "img/display3.0e639536.jpg";